<template>
  <div class="container watermark-container">
    <van-nav-bar title="审批列表" />
    <!--查询表单-->
    <div class="search-div">
      <el-form label-width="50px" size="small">
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="关键字:"
              label-width="auto"
              style="white-space: nowrap"
              ><el-input
                style="width: 60%"
                v-model="searchObj.keyword"
                placeholder="从内容、标题中查找"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="提交人" prop="createId">
              <el-select
                v-model="searchObj.createId"
                filterable
                remote
                reserve-keyword
                placeholder="根据提交人查找"
                :remote-method="searchUsers"
                :loading="leaderLoading"
                style="width: 60%"
              >
                <el-option
                  v-for="item in parentUserList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <!-- 日期范围选择 -->
          <el-form-item label="提交时间" label-width="auto">
            <el-row>
              <!-- 开始日期 -->
              <el-col :span="9">
                <el-date-picker
                  v-model="searchObj.createTimeBegin"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择开始日期"
                  style="width: 100%"
                />
              </el-col>

              <!-- 结束日期 -->
              <el-col :span="1" style="text-align: center; line-height: 36px">
                ~
              </el-col>

              <el-col :span="9">
                <el-date-picker
                  v-model="searchObj.createTimeEnd"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择结束日期"
                  style="width: 100%"
                />
              </el-col>
            </el-row>
          </el-form-item>
        </el-row>

        <el-row style="display: flex">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="mini"
            :loading="loading"
            @click="onRefresh()"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" size="mini" @click="resetData"
            >重置</el-button
          >
          <el-button
            type="success"
            icon="el-icon-download"
            size="mini"
            :loading="exportLoading"
            @click="showExportDialog = true"
          >
            导出
          </el-button>
        </el-row>
      </el-form>
    </div>

    <van-tabs v-model="activeIndex" @click="tabSwitch">
      <van-tab v-for="(item, key) in tabList" :key="key" :title="item.title">
      </van-tab>
    </van-tabs>

    <div class="list-wrap">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :immediate-check="false"
        >
          <van-cell v-for="item in list" @click="info(item.id, item.taskId)">
            <template slot="default">
              <div class="item-wrap">
                <div
                  class="item-header"
                  style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <div style="display: flex; align-items: center">
                    <img
                      src="https://static.dingtalk.com/media/lALOnahFD80CgM0CgA_640_640.png_450x10000q90.jpg"
                      alt=""
                      style="width: 24px; height: 24px; margin-right: 8px"
                    />
                    <h3 style="margin: 0">{{ item.title }}</h3>
                  </div>
                  <div style="text-align: right">
                    <div>{{ item.createTime }}</div>
                    <van-tag
                      :type="item.readStatusId ? 'success' : 'warning'"
                      size="small"
                      style="margin-top: 4px"
                    >
                      {{ item.readStatusId ? '已读' : '未读' }}
                    </van-tag>
                  </div>
                </div>
                <div class="item-block">
                  <p
                    v-for="(value, key) in item.formValues.formShowData"
                    v-if="key !== '图片'"
                  >
                    {{ key }}：<span v-html="value"></span>
                  </p>
                </div>
                <div class="item-status">
                  <span
                    :class="
                      item.status === 1
                        ? '审批中'
                        : item.status === 2
                        ? 'pass'
                        : 'refused'
                    "
                    >{{
                      item.status === 1
                        ? '审批中'
                        : item.status === 2
                        ? '审批通过'
                        : '审批拒绝'
                    }}</span
                  >
                </div>
              </div>
            </template>
          </van-cell>
        </van-list>
      </van-pull-refresh>
    </div>

    <el-dialog
      title="导出提示"
      :visible.sync="showExportDialog"
      width="90%"
      :before-close="handleExportCancel"
    >
      <div style="font-size: 14px; line-height: 1.6">
        是否导出当前查询条件下的审批列表？<br />
        <span style="color: #999">
          如无法预览或下载，请点击右上角选择“在浏览器中打开”。
        </span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleExportCancel">取消</el-button>
        <el-button
          type="primary"
          :loading="exportLoading"
          @click="handleExportConfirm"
        >
          确定导出
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/process'
import addWatermark from '@/utils/watermark'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'process',

  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      loadingData: false,

      pageNo: 1,
      pageSize: 10,
      pages: 1,

      activeIndex: 0,
      tabList: [
        { title: '待处理' },
        { title: '审批历史' },
        { title: '已发起' },
        { title: '我的抄送' },
      ],
      searchObj: {}, // 搜索
      leaderLoading: false, // 人员加载
      parentUserList: [], // 人员列表
      showExportDialog: false, // 必须显式声明
      exportLoading: false, // 导出按钮 loading 变量
    }
  },

  created() {
    this.activeIndex = parseInt(this.$route.params.activeIndex)
    this.onLoad()
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo, // 从 Vuex 中获取 userInfo
    }),
  },
  mounted() {
    // 如果 userInfo 没有值，则调用 Vuex action 获取用户信息
    if (!this.userInfo) {
      this.loadUserInfoAndAddWatermark()
    } else {
      // 如果已有 userInfo，直接添加水印
      this.addWatermark()
    }
  },

  methods: {
    // 获取用户信息缓存
    ...mapActions({
      loadUserInfo: 'fetchUserInfo', // 映射 fetchUserInfo 到组件的方法
    }),
    // 异步方法：先加载用户信息，再添加水印
    async loadUserInfoAndAddWatermark() {
      try {
        await this.loadUserInfo() // 等待 Vuex action 完成
        this.addWatermark() // 用户信息加载完成后添加水印
      } catch (error) {
        // console.error('加载用户信息失败:', error)
      }
    },
    addWatermark() {
      // console.log('打印水印数据:' + this.userInfo.name)
      // 调用水印功能
      addWatermark({
        containerSelector: '.watermark-container', // 添加水印的目标容器
        text: '通用锁具 ' + this.userInfo.name, // 自定义水印文本
        font: '16px Arial',
        color: 'rgba(0, 0, 0, 0.15)',
        width: 200,
        height: 150,
        angle: -30,
      })
    },
    tabSwitch() {
      //tab切换，重新初始化数据
      this.list = []
      this.pageNo = 1
      this.finished = false

      //tabs切换时，如果之前的tab已经滚动到底部（list加载到底部），直接点击其他的tab，将再触发一次onload事件。
      //可能调用2次onLoad()方法，延迟执行，通过时间差解决问题
      setTimeout(() => {
        if (!this.finished) {
          this.onLoad()
        }
      }, 500)
    },

    resetData() {
      this.searchObj = {}

      this.onRefresh()
    },

    onLoad() {
      // 如果正在加载，直接返回
      if (this.loadingData) return

      this.loadingData = true // 标记为加载状态

      // 根据选中的标签，选择不同的请求方法
      switch (this.activeIndex) {
        case 0:
          return this.findPending() // 异步调用
        case 1:
          return this.findProcessed()
        case 2:
          return this.findStarted()
        case 3:
          return this.carbonCopyList()
        default:
          return Promise.resolve()
      }
    },

    onRefresh() {
      if (this.loadingData) return
      // 清空列表数据
      this.finished = false
      // 刷新
      this.refreshing = true
      this.pageNo = 1
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      // 重新加载数据
      this.onLoad().finally(() => {
        this.loadingData = false // 请求完成后清除加载状态
      })
    },

    findPending() {
      console.log(this.pageNo)
      return api
        .findPending(this.pageNo, this.pageSize, this.searchObj)
        .then((response) => {
          console.log(response.data)
          if (this.refreshing) {
            console.log('刷新列表', this.refreshing)
            this.list = []
            this.refreshing = false
          }
          for (let i = 0; i < response.data.records.length; i++) {
            let item = response.data.records[i]
            item.formValues = JSON.parse(item.formValues)
            this.list.push(item)
          }
          this.pages = response.data.pages

          console.log('刷新后数据', response.data)

          this.loading = false
          if (this.pageNo >= this.pages) {
            this.finished = true
          }
          this.loadingData = false //清除加载状态
          this.pageNo++
        })
        .catch((error) => {
          console.error('请求失败:', error) // 打印异常信息
          this.loadingData = false // 请求失败后清除加载状态
        })
    },

    findProcessed() {
      console.log(this.pageNo)
      return api
        .findProcessed(this.pageNo, this.pageSize, this.searchObj)
        .then((response) => {
          console.log(response.data)
          if (this.refreshing) {
            this.list = []
            this.refreshing = false
          }
          for (let i = 0; i < response.data.records.length; i++) {
            let item = response.data.records[i]
            item.formValues = JSON.parse(item.formValues)
            this.list.push(item)
          }
          this.pages = response.data.pages

          this.loading = false
          if (this.pageNo >= this.pages) {
            this.finished = true
          }
          this.loadingData = false // 请求失败后清除加载状态
          this.pageNo++
        })
        .catch(() => {
          this.loadingData = false // 请求失败后清除加载状态
        })
    },
    carbonCopyList() {
      return api
        .carbonCopyList(this.pageNo, this.pageSize, this.searchObj)
        .then((response) => {
          if (this.refreshing) {
            this.list = []
            this.refreshing = false
          }
          for (let i = 0; i < response.data.records.length; i++) {
            let item = response.data.records[i]
            item.formValues = JSON.parse(item.formValues)
            this.list.push(item)
          }
          this.pages = response.data.pages

          this.loading = false
          if (this.pageNo >= this.pages) {
            this.finished = true
          }
          this.loadingData = false // 请求失败后清除加载状态
          this.pageNo++
        })
        .catch(() => {
          this.loadingData = false // 请求失败后清除加载状态
        })
    },

    findStarted() {
      console.log(this.pageNo)
      return api
        .findStarted(this.pageNo, this.pageSize, this.searchObj)
        .then((response) => {
          console.log(response.data)
          if (this.refreshing) {
            this.list = []
            this.refreshing = false
          }
          for (let i = 0; i < response.data.records.length; i++) {
            let item = response.data.records[i]
            item.formValues = JSON.parse(item.formValues)
            this.list.push(item)
          }
          this.pages = response.data.pages

          this.loading = false
          if (this.pageNo >= this.pages) {
            this.finished = true
          }
          this.loadingData = false // 请求失败后清除加载状态
          this.pageNo++
        })
        .catch(() => {
          this.loadingData = false // 请求失败后清除加载状态
        })
    },

    info(id, taskId) {
      // this.$router.push({ path: '/show/' + id + '/' + taskId })
      const loadingInstance = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)',
      })

      this.$router
        .push({ path: '/show/' + id + '/' + taskId })
        .then(() => {
          // 路由跳转成功后关闭 loading
          loadingInstance.close()
        })
        .catch(() => {
          // 路由跳转失败也关闭 loading，避免卡住
          loadingInstance.close()
        })
    },
    // 人员搜索
    async searchUsers(query) {
      if (!query) {
        this.parentUserList = []
        return
      }

      this.leaderLoading = true
      api
        .searchParentUsers(new URLSearchParams({ name: query }))
        .then((response) => {
          this.parentUserList = response.data // 后端返回的用户列表
          this.leaderLoading = false
        })
    },
    // 取消导出
    handleExportCancel() {
      this.showExportDialog = false
    },

    // 确认导出
    async handleExportConfirm() {
      this.exportLoading = true
      try {
        const params = {
          ...this.searchObj,
          selectType: this.activeIndex,
        }
        const res = await api.exportApprovalList(params)

        const fileUrl = res.data

        const a = document.createElement('a')
        a.href = fileUrl
        a.download = fileUrl.substring(fileUrl.lastIndexOf('/') + 1)
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)

        this.$message.success('导出成功')
      } catch (e) {
        this.$message.error('导出失败')
      } finally {
        this.exportLoading = false
        this.showExportDialog = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ .van-nav-bar {
  background: #1d1e20;
}
/deep/ .van-nav-bar__title {
  color: #fff;
}
.container {
  padding-bottom: 50px;
  .list-wrap {
    margin-top: 4px;
    border-top: 1px solid #ebedf0;
  }
  .item-wrap {
    font-size: 12px;
    color: #a7a8a9;
    .item-header {
      display: flex;
      align-items: center;
      img {
        width: 20px;
        height: 20px;
        border-radius: 4px;
        margin-right: 4px;
      }
      h3 {
        flex: 1;
        font-size: 15px;
        color: #000;
        padding: 0;
        margin: 0;
      }
    }

    .item-block {
      padding: 4px 0;
      font-size: 14px;
      p {
        padding: 0;
        margin: 0;
        line-height: 20px;
      }
    }
    .item-status {
      .pass {
        color: #4cb971;
      }
      .refused {
        color: #eb8473;
      }
    }
  }
}
</style>
